/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_All_PaymentsInputs */

const en_admin_payments_all_payments = /** @type {(inputs: Admin_Payments_All_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Payments`)
};

/**
* | output |
* | --- |
* | "All Payments" |
*
* @param {Admin_Payments_All_PaymentsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_payments_all_payments = /** @type {((inputs?: Admin_Payments_All_PaymentsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_All_PaymentsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_payments_all_payments(inputs)
});
export { admin_payments_all_payments as "admin.payments.all_payments" }